if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);

          this.updateSelectedSwatchValue(event);

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          const prevSelected = Array.from(target.options).find((option) => option.getAttribute('selected'));
          if (prevSelected) prevSelected.removeAttribute('selected');

          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');

          if (!selectedDropdownSwatchValue) return;

          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}

(function () {
  function fireChange(el) {
    if (!el) return;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setSelectedCard(container, variantId) {
    if (!container) return;
    container.querySelectorAll('[data-variant-card]').forEach((btn) => {
      btn.classList.toggle('is-selected', btn.getAttribute('data-variant-id') === String(variantId));
    });
  }

  function setFormVariantId(cardsWrap, variantId) {
    if (!cardsWrap) return;

    const formId = cardsWrap.getAttribute('data-product-form-id');
    if (!formId) return;

    const form = document.getElementById(formId);
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    idInput.value = String(variantId);
    fireChange(idInput);
  }

  function selectRadioForOption(variantSelectsEl, optionIndex1Based, value) {
    const radios = variantSelectsEl.querySelectorAll(
      '.variant-cards__hidden-options fieldset input[type="radio"][name$="-'+ optionIndex1Based +'"]'
    );

    if (!radios.length) return false;

    for (const r of radios) {
      if (r.value === value) {
        r.checked = true;
        fireChange(r);
        return true;
      }
    }

    return false;
  }

  function selectDropdownForOption(variantSelectsEl, optionIndex0Based, value) {
    const selects = variantSelectsEl.querySelectorAll('.variant-cards__hidden-options select[name^="options["]');
    const selectEl = selects[optionIndex0Based];
    if (!selectEl) return false;

    const opt = Array.from(selectEl.options).find((o) => o.value === value);
    if (!opt) return false;

    Array.from(selectEl.options).forEach((o) => o.removeAttribute('selected'));
    opt.selected = true;
    opt.setAttribute('selected', 'selected');

    selectEl.value = value;
    fireChange(selectEl);
    return true;
  }

  function applyOptionsToHiddenInputs(variantSelectsEl, optionsArray) {
    optionsArray.forEach((val, idx) => {
      const pos1 = idx + 1;

      const didRadio = selectRadioForOption(variantSelectsEl, pos1, val);
      if (didRadio) return;

      selectDropdownForOption(variantSelectsEl, idx, val);
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-variant-card]');
    if (!btn) return;
    if (btn.disabled) return;

    const variantSelectsEl = btn.closest('variant-selects');
    if (!variantSelectsEl) return;

    const raw = btn.getAttribute('data-variant-options') || '';
    const optionsArray = raw.split('||').map((s) => s.trim());

    applyOptionsToHiddenInputs(variantSelectsEl, optionsArray);

    const cardsWrap = btn.closest('[data-variant-cards]');
    const variantId = btn.getAttribute('data-variant-id');

    setFormVariantId(cardsWrap, variantId);
    setSelectedCard(cardsWrap, variantId);
  });

  document.addEventListener('variant:change', function (e) {
    const variant = e.detail && e.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-variant-cards]').forEach((wrap) => {
      setSelectedCard(wrap, variant.id);
    });
  });
})();
